import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

import type { Station } from '~models/station.model';
import { TranslatePipe } from '~pipes/translate.pipe';

@Component({
  selector: 'app-location-count-label',
  imports: [TranslatePipe],
  templateUrl: './location-count-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationCountLabelComponent {
  readonly stations = input.required<Station[]>();
  readonly stationsCount = computed(() => this.stations().length);
}
